<div class="flex flex-col gap-4">
  @for (formGroup of statusForms().controls; track $index) {
    <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-primary-50">
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameFr" [label]="'local.french' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameNl" [label]="'local.dutch' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="formGroup.controls.nameEn" [label]="'local.english' | translate"/>
      </div>
      <div>
        <elcia-color-picker [control]="formGroup.controls.color"/>
      </div>

      <elcia-button
        [icon]="formGroup.enabled ? 'save' : 'edit'"
        [severity]="formGroup.enabled ? 'primary' : 'secondary'"
        (click)="toggleFormGroup(formGroup.value.id)"/>
      <elcia-button
        icon="delete"
        severity="danger"
        variant="text"
        (click)="deleteStatus(formGroup.value.id)"/>
    </div>
  }

  <div class="flex justify-between items-center gap-6 p-4 rounded-xl border-1 border-dashed border-primary-100">
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameFr" [label]="'local.french' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameNl" [label]="'local.dutch' | translate"/>
    </div>
    <div class="flex-1">
      <elcia-text-input [control]="createForm.controls.nameEn" [label]="'local.english' | translate"/>
    </div>
    <div>
      <elcia-color-picker [control]="createForm.controls.color"/>
    </div>
    <elcia-button
      icon="plus"
      severity="primary"
      [disabled]="createForm.invalid"
      (click)="submitCreate()"/>
    <div class="w-[36px]"></div>
  </div>
</div>
